import { Card, CardContent, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";

const ispLabels = [
  "Zol",
  "Zol (Liquid Home)",
  "Conti Touch",
  "Utande (Umax)",
  "Telco",
  "zol",
  "econet",
  "TelOne",
  "Unknown",
  "Econet",
  "NetOne",
  "zol2",
  "The Livestreaming Company",
  "Starlink",
  "None",
];

const ispSpeeds = [20, 14, 10, 7, 5, 4, 3, 3, 2.5, 2, 1.5, 1, 0.8, 0.5, 0.2];

export default function ISPPerformanceWidget() {
  return (
    <Card sx={{ height: "100%", borderRadius: 3, width: "100%" }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          ISP Performance (Avg Speed)
        </Typography>

        <BarChart
          layout="horizontal"
          xAxis={[
            {
              label: "internet_upload_speed",
              scaleType: "linear",
            },
          ]}
          yAxis={[
            {
              data: ispLabels,
              scaleType: "band",
            },
          ]}
          series={[
            {
              data: ispSpeeds,
            },
          ]}
          height={350}
        />
      </CardContent>
    </Card>
  );
}
